const PRE_DELIVERY_BLOCKED = new Set([
  'DELIVERED',
  'CANCELLED',
  'RETURNED',
  'PAYMENT_EXPIRED',
  'PENDING_PAYMENT',
]);
const RETURN_WINDOW_MS = 24 * 60 * 60 * 1000;

export function canAdminCancel(status: string): boolean {
  return !PRE_DELIVERY_BLOCKED.has((status ?? '').toUpperCase());
}

export function isWithinReturnWindow(deliveredAt?: string | null, nowMs = Date.now()): boolean {
  if (!deliveredAt) return false;
  const t = new Date(deliveredAt).getTime();
  return Number.isFinite(t) && nowMs - t <= RETURN_WINDOW_MS;
}

export function canAdminReturn(order: {
  status: string;
  deliveredAt?: string | null;
  deliveredAtIso?: string | null;
}): boolean {
  const deliveredAt = order.deliveredAt ?? order.deliveredAtIso;
  return (order.status ?? '').toUpperCase() === 'DELIVERED' && isWithinReturnWindow(deliveredAt);
}

export function needsCodCashPayout(order: {
  paymentMethod?: string | null;
  method?: string | null;
  collectionMode?: string | null;
}): boolean {
  const method = (order.paymentMethod ?? order.method ?? '').toUpperCase();
  return method === 'COD' && (order.collectionMode ?? '').toUpperCase() === 'CASH';
}
